interface IRadio extends React.HTMLProps<HTMLInputElement> {
  title: string;
  value: string;
  customClassName?: string;
  inputClassname?: string;
}

const CustomRadio = ({
  title,
  value,
  inputClassname,
  customClassName,
  ...props
}: IRadio) => {
  return (
    <div className="flex gap-2 items-center">
      <input
        {...props}
        type="radio"
        id={value}
        value={value}
        className={`accent-farm-shop-500 ${inputClassname}`}
      />
      <label className={customClassName} htmlFor={value}>
        {title}
      </label>
    </div>
  );
};

export default CustomRadio;
